import React from "react";
import { Divider, Button, Form, Col } from "antd";
import { Field, reduxForm, getFormValues } from "redux-form";
import { connect } from "react-redux";
import {
    selectField,
    plainTextField,
} from "../Form/FieldRenders";
import {
    searchAllUserOrderHistory
  } from "../../actions/actionsOrders";

  function serialize(obj) {
    var str = [];
    for(var p in obj)
       str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    return str.join("&");
  }
class SearchView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit(props) {
        
        let params = serialize(props)
        
        if (params) {

            params = "?" + params
        }


        this.props.searchAllUserOrderHistory(params)
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div className="chart-row">
                <Divider>Order Search </Divider>
                <Form onSubmit={handleSubmit(this.onFormSubmit)}>
                    <div style={{alignItems: "end", display: "flex", justifyContent: "center"}}>
                        <Col span={4}>
                            <Field
                                label={"Order ID / GMA ID"}
                                name="transaction_id"
                                required={false}
                                size={"large"}
                                component={plainTextField}
                            />
                        
                        </Col>

                        <Col span={4}>
                            <Field
                                label={"Status"}
                                name="status"
                                required={false}
                                size={"large"}
                                options={[
                                    {
                                        text: "None",
                                        value: null
                                    },
                                    {
                                        text: "Successful",
                                        value: "successful"
                                    },
                                    {
                                        text: "Replacement Box",
                                        value: "replacement_box"
                                    },
                                    {
                                        text: "Free Sample",
                                        value: "free_sample"
                                    },
                                    {
                                        text: "Partially Refunded",
                                        value: "partially_refunded"
                                    },
                                    {
                                        text: "Refunded",
                                        value: "refunded"
                                    },
                                ]}
                                component={selectField }
                            />
                        </Col>
                        <Col span={4}>
                            <Field
                                label={"Email"}
                                name="email"
                                required={false}
                                size={"large"}
                                component={plainTextField }
                            />
                        </Col>
                        <Col span={4}>
                            <Field
                                label={"Shipment Status"}
                                name="shipment_status"
                                required={false}
                                size={"large"}
                                options={[
                                    {
                                        text: "None",
                                        value: null
                                    },
                                    {
                                        text: "Awaiting Shipment",
                                        value: "awaiting_shipment"
                                    },
                                    {
                                        text: "Gift Card",
                                        value: "gift_card"
                                    },
                                    {
                                        text: "Shipped",
                                        value: "shipped"
                                    },
                                    {
                                        text: "Cancelled",
                                        value: "cancelled"
                                    },
                                    {
                                        text: "Delayed",
                                        value: "delayed"
                                    },
                                    {
                                        text: "On Hold",
                                        value: "on_hold"
                                    }
                                ]}
                                component={selectField }
                            />
                        </Col>

                        <Col span={4}>
                            <br />
                            <br />
                            <Button
                                loading={this.props.formLoading || this.props.ordersLoading}
                                htmlType="submit"
                                block
                                size="large"
                                type="primary"
                                icon="search"
                            >
                                Search
                            </Button>
                        </Col>
                    </div>
                </Form>
            </div>
        );
    }
}


SearchView = reduxForm({
    form: "SearchViewForm",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    enableReinitialize: false
})(SearchView);

function mapStateToProps(state) {
    return {
        
        ordersLoading: state.orders.orders_loading,
        formValues: getFormValues("SearchViewForm")(state)
    };
}

export default connect(
    mapStateToProps,
    { searchAllUserOrderHistory }
)(SearchView);
